import { useEffect } from "react";
import { PlayerPanel } from "@/components/account/PlayerPanel";
import { GmPanel } from "@/components/account/GmPanel";
import { useAuth } from "@/lib/auth-context";

// Shared layout for the whole account/economy area ("adminka"): a player
// navigation panel on the left (always), the actual page content in the
// middle, and a GM navigation panel on the right - only for gmlevel=4
// accounts, same gating as the GM section itself.
//
// Also refreshes the shared /api/me user state (character cash, is_gm) on
// every mount - since each admin page is its own route, React Router
// unmounts/remounts a fresh AccountShell on every navigation between them
// (Účet -> Horowitzova banka -> GM sekce -> ...), so this keeps the numbers
// as current as possible without a hard page reload. Individual pages still
// do their own data fetching for whatever else they show (investments,
// company detail, ...) - this only covers the AuthProvider-held user object,
// which AccountPage in particular has no other way to refresh.
export const AccountShell = ({ isGm, testId, children }) => {
  const { refreshUser } = useAuth();

  useEffect(() => {
    refreshUser?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="min-h-[70vh] px-6 pb-24 pt-40" data-testid={testId}>
      <div className="mx-auto grid max-w-[1584px] grid-cols-1 gap-6 lg:grid-cols-[240px_minmax(0,1fr)_240px]">
        <PlayerPanel />
        <div className="min-w-0">{children}</div>
        {isGm ? <GmPanel /> : <div className="hidden lg:block" />}
      </div>
    </section>
  );
};
